import React from "react";
import Header from "./Header";
import PageHeader from "./PageHeader";
import Sidebar from "./Sidebar";
export default function AppContainer(props) {
  return (
    <>
      <div>
        {/* PAGE */}
        <div className="page">
          {/* HEADER */}
          <Header />
          {/* END HEADER */}
          {/* SIDEBAR */}
          <Sidebar />
          {/* END SIDEBAR */}
          {/* MAIN-CONTENT */}
          <div className="main-content side-content pt-0">
            <div className="main-container container-fluid">
              <div className="inner-body">
                {/* Page Header */}
                <br />
                <br />
                <br />
                <PageHeader title={props.title} />
                {/* End Page Header */}
                {/*Row*/}
                {props.children}
                {/* Row end */}
              </div>
            </div>
          </div>
          {/* END MAIN-CONTENT */}
          {/* FOOTER */}
          <div className="main-footer text-center">
            <div className="container">
              <div className="row row-sm">
                <div className="col-md-12">
                  <span>
                    Copyright &copy; 2024 to {new Date().getFullYear()}
                    &nbsp;powered by &nbsp;
                    <a href="https://www.araknerd.com/" target="blank">
                      Araknerd
                    </a>
                    &nbsp; All rights reserved.
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* END FOOTER */}
        </div>
        {/* END PAGE */}
      </div>
    </>
  );
}
